import { useCallback, useEffect, useState } from 'react';
import { getPremiacaoTabelaNomes, getPremiacaoTabelaSegmentos } from '@spark/services/premiacao';
import { notification } from '@spark/ui-components/utils/notification';
import { mapValuesToSelectOptions } from '../utils/premiacaoMultiSelectFilters';

export const usePremiacaoConsolidadoFiltrosOpcoes = (show) => {
  const [nomesTabela, setNomesTabela] = useState([]);
  const [segmentos, setSegmentos] = useState([]);
  const [loadingOpcoes, setLoadingOpcoes] = useState(false);

  const carregarOpcoes = useCallback(async () => {
    try {
      setLoadingOpcoes(true);
      const [nomes, segmentosLista] = await Promise.all([
        getPremiacaoTabelaNomes(),
        getPremiacaoTabelaSegmentos()
      ]);
      setNomesTabela(Array.isArray(nomes) ? nomes : []);
      setSegmentos(Array.isArray(segmentosLista) ? segmentosLista : []);
    } catch (error) {
      console.error('Erro ao carregar opções de filtro da premiação consolidada:', error);
      notification.error(
        error?.message || 'Não foi possível carregar as opções de filtro',
        'Erro ao carregar filtros'
      );
      setNomesTabela([]);
      setSegmentos([]);
    } finally {
      setLoadingOpcoes(false);
    }
  }, []);

  useEffect(() => {
    if (show) {
      carregarOpcoes();
    }
  }, [show, carregarOpcoes]);

  return {
    nomeTabelaOpcoes: mapValuesToSelectOptions(nomesTabela),
    segmentoOpcoes: mapValuesToSelectOptions(segmentos),
    loadingOpcoes
  };
};
